import {Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from "@angular/core";
import {Router} from '@angular/router';
import {AlertPanelComponent, AlertPanelService} from "@amlCore/components";
import {DictionaryService, UserService, ResourceService} from "@amlCore/services";
import {IDopInfoItem} from "../../interfaces";
import {Transaction} from "../../models";
import {AbstractControl, FormArray, FormControl, FormGroup} from "@angular/forms";
import {Subject} from "rxjs";
import {TransactionSubject} from "../../models/transaction/transactionSubject.model";
import {CheckTransactionSubject} from "../../models/transaction/checkTransactionSubject.model";
import {pairwise, startWith, takeUntil} from "rxjs/operators";

@Component({
  selector: "app-check-transaction-subject",
  templateUrl: "./checkTransactionSubject.component.html"
})

export class CheckTransactionSubjectComponent implements OnInit, OnDestroy {
  @ViewChild("alertObjSave") alertObjToSave: AlertPanelComponent;
  @Input() isReadOnly;
  @Input() submitted = false;
  @Input() formGroupApp: FormGroup;
  @Input() transaction: Transaction;
  @Input() dictionary: { [name: string]: Array<any>; } = {};
  @Output() resultRevert: any = new EventEmitter<any>();
  data: CheckTransactionSubject;
  checkSubject: TransactionSubject;

  public dictDate: string;
  public idSubject: string;
  public dictId: string;
  public dictRowId: string;
  public dictParentRowId: string;
  public dictNumber: string;
  public dictType: string;
  public dictName: string;
  public mvkResh: any;
  public msLead: any;
  public msLeadVisible = false;
  public msFound: any;
  public msFoundVisible = false;
  public fts: any;
  public ftsVisible = false;
  public msAdr: any;
  public msAdrVisible = false;
  public passport: any;
  public passportVisible = false;
  public dopNames: any[] = [];
  public isReadOnlyAccess = false;
  isLoaded = false; // Признак, что форма загружена
  checkResult = null;
  disabled = false;
  viewForm: FormGroup;
  $destroy = new Subject();
  constructor(
    protected router: Router,
    private resourceSrv: ResourceService,
    protected alertPanelSrv: AlertPanelService,
    protected dictSrv: DictionaryService) {

  }

  ngOnInit() {
    this.data = this.formGroupApp?.value;
    this.checkSubject = this.transaction[this.data.participantType];
    this.initDopInfo();
    this.formGroupApp.get('checkResult').valueChanges.pipe(takeUntil(this.$destroy))
      .pipe(startWith(null), pairwise())
      .subscribe(([prev, next]: [any, any]) => {
        //Если в ранее отклоненном результате/результатах проверки по перечням, изменено значение на = 1 "Полное совпадение",
        //нужно передать далее для возврата из отклоненных
        if(prev == '0' && next == '1'){
          this.resultRevert.emit();
        }
      } );
  }

  /* Подготовка данных их доп.полей*/
  private initDopInfo() {
    this.data.dopInfos.forEach(item => {
      switch (item.code) {
        case "dictDate":
          this.dictDate = item.value;
          break;
        case "idSubject":
          this.idSubject = item.value;
          break;
        case "dictId":
          this.dictId = item.value;
          break;
        case "dictRowId":
          this.dictRowId = item.value;
          break;
        case "dictParentRowId":
          this.dictParentRowId = item.value;
          break;
        case "dictNumber":
          this.dictNumber = item.value;
          break;
        case "dictType":
          this.dictType = item.value;
          break;
      }
    });

    this.dopNames = this.data.dopInfos.filter((item) => item.name);

    if (this.dictRowId) {
      if (this.dictType === "mvk") {
        this.resourceSrv.getMvkReshIdBySubjectId(this.dictRowId).subscribe((dataMvk) => {
          this.mvkResh = dataMvk;
        });
      }

      if (this.dictType === "mslead") {
        this.resourceSrv.getMsLead(this.dictRowId).subscribe((dataMslead) => {
          this.msLead = dataMslead;
        });
      }

      if (this.dictType === "msfound") {
        this.resourceSrv.getMsFound(this.dictRowId).subscribe((dataMsfound) => {
          this.msFound = dataMsfound;
        });
      }
      if (this.dictType === "fts") {
        this.resourceSrv.getFts(this.dictRowId).subscribe((dataFts) => {
          this.fts = dataFts;
        });
      }
      if (this.dictType === "ms_adr_info") {
        this.resourceSrv.getMsAdr(this.dictRowId).subscribe((dataMsadrinfo) => {
          this.msAdr = dataMsadrinfo;
        });
      }
      if (this.dictType === "passport") {
        this.resourceSrv.getPassport(this.dictRowId).subscribe((dataPassport) => {
          this.passport = dataPassport;
        });
      }
    }

    this.dictName = this.dictSrv.getDictNameByCode(this.dictType, this.dictionary.criticallists);
  }

  isVisibleTitleSubject(subject: CheckTransactionSubject): boolean {
    return this.isSubjectData(subject?.dossierInfo?.clientInfo?.typeSubject);
  }

  public isSubjectData(code: string): boolean {
    const subjectListCodes = [
      'svedAU', 'svedIOU', 'svedUDS',
      'svedClient', 'svedPredst', 'svedVPR',
      'svedBV'];
    return subjectListCodes.includes(code);
  }

  public getDopInfoName(dopInfoItem: IDopInfoItem): string {
    if (dopInfoItem && dopInfoItem.code === "characterPDL") {
      const info = (this.dictionary.affiliationpdl || []).find((item: any) => item.code === dopInfoItem.value);
      return (info?.name || "");
    }
    if (dopInfoItem && dopInfoItem.code === "country") {
      const info = (this.dictionary.oksm || []).find((item: any) => item.kod === dopInfoItem.value);
      return (info?.name || "");
    }
    return (dopInfoItem?.value || "");
  }

  public getTypeSubjectName(code: string): string {
	   return this.dictSrv.getTypeSubjectName(code, this.dictionary.typesubjects);
  }

  public msLeadChange() {
    this.msLeadVisible = !this.msLeadVisible;
  }

  public msFoundChange() {
    this.msFoundVisible = !this.msFoundVisible;
  }

  public msAdrChange() {
    this.msAdrVisible = !this.msAdrVisible;
  }

  public ftsChange() {
    this.ftsVisible = !this.ftsVisible;
  }

  public passportChange() {
    this.passportVisible = !this.passportVisible;
  }

  f(field: string): FormControl {
    return this.formGroupApp.get(field) as FormControl;
  }

  fArray(field: string): FormArray {
    return this.formGroupApp.get(field) as FormArray;
  }

  fGroup(control: AbstractControl): FormGroup {
    return control as FormGroup;
  }

  ngOnDestroy(): void {
    this.$destroy.next();
    this.$destroy.complete();
  }
}
